import { unwrap, flatUnwrap } from "@nuxtjs/mdc/dist/runtime/utils/node";
export const useUnwrap = () => ({
  unwrap,
  flatUnwrap
});
